import { Hydrate, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type PropsWithChildren } from 'react'

import { useQueryClient } from '../../hooks/useQueryClient'

type QueryProviderProps = {
  dehydratedState?: unknown
}

export function QueryProvider({
  children,
  dehydratedState,
}: PropsWithChildren<QueryProviderProps>) {
  const queryClient = useQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools position='bottom-right' initialIsOpen={false} />
      )}

      <Hydrate state={dehydratedState}>{children}</Hydrate>
    </QueryClientProvider>
  )
}
